var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "lazy-image" }, [
    _c("div", { staticClass: "lazy-image__placeholder" }, [
      _c("div", {
        staticClass: "lazy-image__container lazy-image__container--small",
        class: {
          "lazy-image__container--unload": _vm.largeLoaded,
          "lazy-image__container--contain": _vm.contain
        },
        style: { "background-image": "url(" + _vm.srcSmall + ")" }
      }),
      _vm._v(" "),
      _c("div", {
        staticClass: "lazy-image__container lazy-image__container--large",
        class: {
          "lazy-image__container--loaded": _vm.largeLoaded,
          "lazy-image__container--contain": _vm.contain
        },
        style: { "background-image": "url(" + _vm.src + ")" }
      })
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-517647e0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// /Users/fabianschneider/Documents/Development/code/wordpress/lineabertoli/web/app/themes/lineabertoli/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-517647e0","hasScoped":false,"buble":{"transforms":{}}}!/Users/fabianschneider/Documents/Development/code/wordpress/lineabertoli/web/app/themes/lineabertoli/node_modules/vue-loader/lib/selector.js?type=template&index=0!./scripts/vue/lazy-image.vue
// module id = 31
// module chunks = 0